<template>
  <SpinnerComp v-if="loading" />
  <div v-else class="mt-8">
    <label for="dataSelect" class="mr-2 font-bold">Seleccionar:</label>
    <select v-model="selectedOption" id="dataSelect" class="border p-2 rounded">
      <option value="familias">Familias</option>
      <option value="categorias">Categorías</option>
      <option value="subcategorias">Sub Categorías</option>
    </select>

    <div class="overflow-x-auto mt-4">
      <table class="min-w-full border border-gray-200">
        <thead>
          <tr class="bg-gray-700 text-white">
            <th
              v-for="(header, index) in headers[selectedOption]"
              :key="index"
              class="border-t border-gray-300 p-2"
            >
              {{ header }}
            </th>
            <th class="border-t border-gray-300 p-2">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in paginatedData" :key="index">
            <td
              v-for="(header, key) in headers[selectedOption]"
              :key="key"
              class="border-t border-gray-200 p-2"
            >
              {{ item[key] }}
            </td>
            <td class="border-t border-gray-300 p-2 text-center">
              <div class="sm:flex sm:justify-center sm:space-x-2">
                <button
                  class="bg-yellow-300 text-white mr-2 w-8 h-8 rounded-full"
                  @click="editItem(item)"
                >
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  class="bg-red-500 text-white w-8 h-8 rounded-full"
                  @click="deleteItem(item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="mt-4 flex justify-between items-center">
      <button
        @click="changePage(currentPage - 1)"
        :disabled="currentPage === 1"
        :class="{
          'bg-blue-500 text-white cursor-not-allowed opacity-50':
            currentPage === 1,
          'bg-blue-500 text-white': currentPage !== 1,
        }"
        class="px-4 py-2 rounded mr-2 transition-all"
      >
        Anterior
      </button>
      <span class="text-gray-600">
        Página {{ currentPage }} de {{ totalPages }}
      </span>
      <button
        @click="changePage(currentPage + 1)"
        :disabled="currentPage === totalPages"
        :class="{
          'bg-blue-500 text-white cursor-not-allowed opacity-50':
            currentPage === totalPages,
          'bg-blue-500 text-white': currentPage !== totalPages,
        }"
        class="px-4 py-2 rounded ml-2 transition-all"
      >
        Siguiente
      </button>
    </div>

    <!-- Modal -->
    <div
      v-if="dataForm"
      class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center"
    >
      <div class="bg-white p-6 rounded shadow-lg w-96">
        <h3 class="font-bold mb-2">Editar {{ selectedOption }}</h3>
        <form @submit.prevent="enviar">
            <div v-if="selectedOption === 'categorias'" class="mt-4">
            <label class="block mb-2">Familia:</label>
            <input
              v-model="familiaNombre"
              class="border p-2 rounded w-full"
              readonly
              disabled
            />
          </div>

          <div v-if="selectedOption === 'subcategorias'" class="mt-4">
            <label class="block mb-2">Familia:</label>
            <input
              v-model="familiaNombre"
              class="border p-2 rounded w-full"
              readonly
              disabled
            />

            <label class="block mt-2 mb-2">Categoría:</label>
            <input
              v-model="categoriaNombre"
              class="border p-2 rounded w-full"
              readonly
              disabled
            />
          </div>
          <label class="block mb-2">Identificador:</label>
          <input
            v-model="dataForm.identificador"
            class="border p-2 rounded w-full"
          />

          <label class="block mt-2 mb-2">Nombre:</label>
          <input
            v-model="dataForm.nombre"
            class="border p-2 rounded w-full"
          />

          <div class="mt-4">
            <button
              type="submit"
              class="bg-blue-500 text-white px-4 py-2 rounded mr-2"
            >
              Guardar
            </button>
            <button
              type="button"
              class="bg-gray-400 text-white px-4 py-2 rounded"
              @click="cancelEdit"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeModal"
      @confirm="deleteIdentificador"
    />
  </div>
</template>

<script>
import DeleteComp from "@/components/DeleteComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  data() {
    return {
      loading: false,
      isDeleteOpen: false,
      selectedOption: "familias",
      currentPage: 1,
      perPage: 8,
      data: {
        familias: [],
        categorias: [],
        subcategorias: [],
      },
      headers: {
        familias: { identificador: "Identificador", nombre: "Nombre" },
        categorias: { identificador: "Identificador", nombre: "Nombre" },
        subcategorias: { identificador: "Identificador", nombre: "Nombre" },
      },
      dataForm: null,
    };
  },
  components: {
    DeleteComp,
    SpinnerComp,
  },
  methods: {
    closeModal() {
      this.isDeleteOpen = false;
    },
    getData() {
      this.loading = true;
      this.dataForm = null;
      this.$axios.get("/getFam").then((response) => {
        this.data.familias = response.data.familias || [];
      });

      this.$axios.get("/getCat").then((response) => {
        this.data.categorias = response.data.categoria || [];
      }).catch(() =>{
        return;
      });

      this.$axios
        .get("/getSubC")
        .then((response) => {
          this.data.subcategorias = response.data.sub_categorias || [];
        }).catch(() =>{
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editItem(item) {
      this.dataForm = { ...item };
    },
    enviar() {
      if(this.selectedOption === 'familias'){
        this.$axios.put(`/updateFam/${this.dataForm.id}`,{
          nombre: this.dataForm.nombre,
          identificador: this.dataForm.identificador
        }).then(response =>{
          alert(response.data.message);
          this.getData();
        }).catch(error => {
          if (error.response) {
            alert(error.response.data.message);
          }
        });
      }else if(this.selectedOption === 'categorias'){
        this.$axios.put(`/updateCat/${this.dataForm.id}`,{
          nombre:this.dataForm.nombre,
          identificador:this.dataForm.identificador,
          familia_id: this.dataForm.familia
        }).then(response => {
          alert(response.data.message);
          this.getData();
        }).catch(error => {
          if (error.response) {
            alert(error.response.data.message);
          }
        })
      }else{
        this.$axios.put(`/updateSub/${this.dataForm.id}`,{
          nombre:this.dataForm.nombre,
          identificador:this.dataForm.identificador,
          familia_id: this.dataForm.familia,
          categoria_id: this.dataForm.categoria
        }).then(response =>{
          alert(response.data.message);
          this.getData();
        }).catch(error => {
          if (error.response) {
            alert(error.response.data.message);
          }
        });
      }
    },
    cancelEdit() {
      this.dataForm = null;
    },
    deleteItem(item) {
      this.isDeleteOpen = true;
      this.deleteMessage = `¿Estás seguro de eliminar este elemento a: ${item.nombre}?`;
      this.dataDelete = item.id;//dataDelete la data de quien se va a elimianr como acceder id
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    deleteIdentificador(){
      let ruta = null;
      if(this.selectedOption === 'familias') ruta = `/deleteFam/${this.dataDelete}`;
      else if (this.selectedOption === 'categorias') ruta = `/deleteCat/${this.dataDelete}`;
      else ruta = `/deleteSub/${this.dataDelete}`;
      this.$axios.delete(ruta).then(response =>{
        alert(response.data.message);
        this.closeModal();
        this.getData();
      }).catch(error => {
        console.log(error);
      });
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.data[this.selectedOption].slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.data[this.selectedOption].length / this.perPage);
    },
    familiaNombre() {
      if (this.data.familias && this.dataForm.familia) {
        const familia = this.data.familias.find(
          (f) => f.id === this.dataForm.familia
        );
        return familia ? familia.nombre : "Familia no encontrada";
      }
      return "Familia no disponible";
    },
    categoriaNombre() {
      if (this.data.categorias && this.dataForm.categoria) {
        const categoria = this.data.categorias.find(
          (c) => c.id === this.dataForm.categoria
        );
        return categoria ? categoria.nombre : "Categoría no encontrada";
      }
      return "Categoría no disponible";
    },
  },
};
</script>
